import prospectLogo from '../assets/images/logo/propspectLogo.png';
import creatorFoundationLogo from '../assets/images/logo/creatorFoundationLogo.png';
import nxgenvartifyLogo from '../assets/images/logo/nxgenvartifyLogo.png';
import { getCachedOrgBranding, isExpiredSignedMediaUrl } from './orgBrandingCache';
import {
  isCreatorFoundationDomain,
  isNxgenVarsityDomain,
  isTpiDomain,
} from './domainUtils';

/** Fallback static logos when org branding API/cache is unavailable. */
export const getLogoByDomainAndAlt = () => {
  if (isTpiDomain()) {
    return {
      logo: prospectLogo,
      alt: 'Prospect LMS Logo'
    };
  } else if (isCreatorFoundationDomain()) {
    return {
      logo: creatorFoundationLogo,
      alt: 'Creator Foundation LMS Logo'
    };
  } else if (isNxgenVarsityDomain()) {
    return {
      logo: nxgenvartifyLogo,
      alt: 'Nxgen Varsity LMS Logo'
    };
  } else {
    // Default logo for other domains - using prospect logo
    return {
      logo: prospectLogo,
      alt: 'Prospect LMS Logo'
    };
  }
};

// Same as superadminlms OrganizationManagement: use BACKEND_URL for relative logo paths
const backendBase = process.env.REACT_APP_BACKEND_URL?.replace(/['"]/g, '') || process.env.REACT_APP_API_URL?.replace(/['"]/g, '') || '';

/** Logo/alt from organization_details (set after login). Use in sidebars. Full URL used as-is; relative path prefixed with backend URL (same as OrganizationManagement.jsx). */
export const getOrgLogoFromStorage = () => {
  try {
    const raw = localStorage.getItem('organization_details');
    if (!raw) return null;
    const details = JSON.parse(raw);
    const logoPath = details?.logo || details?.favicon;
    const name = details?.name;
    if (!logoPath) return null;
    if (/^https?:\/\//i.test(logoPath) && isExpiredSignedMediaUrl(logoPath)) {
      return null;
    }
    const logoUrl = /^https?:\/\//i.test(logoPath)
      ? logoPath
      : `${backendBase.replace(/\/$/, '')}${logoPath.startsWith('/') ? '' : '/'}${logoPath}`;
    return {
      logo: logoUrl,
      alt: name ? `${name} Logo` : 'Organization Logo'
    };
  } catch {
    return null;
  }
};

/** Logo from org branding cache (`lms_org_branding_v1`) if present for this origin. */
export const getOrgLogoFromBrandingCache = () => {
  try {
    const cached = getCachedOrgBranding();
    if (!cached?.logo) return null;
    return {
      logo: cached.logo,
      alt: cached.name ? `${cached.name} Logo` : 'Organization Logo',
    };
  } catch {
    return null;
  }
};

/** Prefer org logo from cache/storage, fallback to domain-based logo. Use in admin/user sidebars. */
export const getSidebarLogo = () =>
  getOrgLogoFromStorage() || getOrgLogoFromBrandingCache() || getLogoByDomainAndAlt();
